module.exports = __webpack_public_path__ + "static/media/logo-grant-management.86e7e6b6.svg";